import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PuffLoader } from "react-spinners";
import { toast } from "react-toastify";

import PhoneInput from "react-phone-number-input";
import IconButton from "@mui/material/IconButton";


import { BackIcon, BrandActiveNavIcon, BrandNavIcon, CampaignActiveNavIcon, CampaignNavIcon, CollaborationActiveNavIcon, CollaborationNavIcon, CreatorActiveNavIcon, CreatorCatalogueLogo, CreatorCLogo, CreatorNavIcon, InfoIcon, ListIcon, PackActiveNavIcon, PackNavIcon, ProfileActiveNavIcon, ProfileNavIcon, SmileyWink } from "Components/icons/Icons";

import { logout, resetLoadSuccessStates, setUser } from "states/auth/authSlice";
import LightTooltip from "Components/common/LightToolTip";

import { persistor } from "app/store"; // Import the persistor
import { GetPendingCollaborationsCount, GetUnreadMessageCountApi } from "actions/chatActions";
import {
  ForgotPasswordApi,
  getNotificationsApi,
  LoginApi, RegisterApi
} from "actions/authAction";
import NotificationsPanel from "Components/modals/NotificationsPanel";
import { isSupported, requestForToken } from "services/firebase";
import { validateEmail } from "utils/mailUtils";
import { getUserData } from "api/authApi";
import LoadingOverlay from "../common/loading/LoadingOverlay";
import { Menu, X } from "lucide-react";
import NavItemButton from "../common/button/NavItemButton";
import { isImageUrlExpiredOrInvalid, waitForElement } from "utils/commonUtils";
import useFetchUserData from "hooks/useFetchUserData";
import { startTour, stopTour } from "states/guideTour/guideTourSlice";
import {
  // layoutStepsCreatorManuallyUpdateInstagramDataAfterClickAvatar, 
  // layoutStepsCreatorManuallyUpdateInstagramDataAfterClickProfile
} from "joyride/stepsCommon";
import AuthModal from "../modals/authModal/AuthModal";
import { ELEMENT_IDS, INITIAL_FIELDS } from "constants/constants";
import SignUpOptionsModal from "../modals/authModal/SignUpOptionsModal";
import SignUpModalWrapper from "../modals/authModal/SignUpModalWrapper";
import SignUpFormFields from "../modals/authModal/SignUpFormFields";
import ModalWrapper from "../modals/common/ModalWrapper";
import MobileNavbar from "./common/MobileNavbar";
import NavbarDesktopV1 from "./common/NavbarDesktopV1";
import NavbarDesktopV2 from "./common/NavbarDesktopV2";
import TitleHeaderPage from "../common/title/TitleHeaderPage";
// import { getNotificationsApi } from "Common/Repository";



const Navbar = ({ titlePageReplaceLogoAtMobile, isDisplayHeaderAtMobile = true, isDisplayMenuAtMobile = true }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const url = location.pathname;
  const { instagramData } = useSelector((state) => state.creatorDetails);
  const { isRunning, nameTour } = useSelector((state) => state.guideTour);

  // const [isConnected, setIsConnected] = useState(socket.connected);
  const [isOpen, setIsOpen] = useState(false);

  // const [shouldRedirect, setShouldRedirect] = useState(false);

  const [filteredNavbarItems, setFilterNavbarItems] = useState([]);

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [errors, setErrors] = useState([]);

  // New Redux States
  const {
    loading,
    user,
    success,
    error,
    loginError,
    token,
    signUpSuccess,
    forgotPassLoading,
    forgotPassSuccess,
  } = useSelector((state) => state.auth);

  const isLogin = user !== null;

  const { unReadMessagesCount } = useSelector((state) => state.chat);

  // function openWhatsAppChat() {
  //   window.open("https://wa.me/13024401582", "_blank");
  // }
  // window.open("https://wa.me/13024401582?text=Hi%2C%20I%20have%20a%20question%20from%20your%20website", "_blank");


  const [signUpOptions, setSignUpOptions] = useState(false);

  const [logInOptions, setLogInOptions] = useState(false);

  const [forgotPassOptions, setForgotPassOptions] = useState(false);

  const [role, setRole] = useState(null);

  const [modalType, setModalType] = useState("");

  const [notifications, setNotifications] = useState(false);

  const [inputFields, setInputFields] = useState(INITIAL_FIELDS);


  $(document).ready(function () { // eslint-disable-line no-undef
    $('input[type="date"]').each(function () { // eslint-disable-line no-undef
      var $el = $(this), // eslint-disable-line no-undef
        $this_placeholder = $el.closest('label').find('.custom-placeholder');

      if (!$el.val()) {
        $this_placeholder.show(); // eslint-disable-line no-undef
      }

      $el.on('change', function () {
        if ($el.val()) {
          $this_placeholder.hide(); // eslint-disable-line no-undef
        } else {
          $this_placeholder.show(); // eslint-disable-line no-undef
        }
      });
    });
  });

  function handleInputFocus(event) {
    var $el = $(event.target), // eslint-disable-line no-undef
      $this_placeholder = $el.closest('label').find('.custom-placeholder');

    $this_placeholder.hide(); // eslint-disable-line no-undef
  }

  function handleInputBlur(event) {
    var $el = $(event.target), // eslint-disable-line no-undef
      $this_placeholder = $el.closest('label').find('.custom-placeholder');

    if (!$el.val()) {
      $this_placeholder.show(); // eslint-disable-line no-undef
    }
  }


  const getUnreadMessages = () => {
    if (token !== "") {
      try {
        dispatch(GetUnreadMessageCountApi({ token, dispatch }));
      } catch (error) { }
    }
  };

  const getPendingCollaborationRequest = () => {
    if (token !== "") {
      try {
        let data = { user_id: user?.id };
        let header = {
          Authorization: `Bearer ${token}`,
        };
        dispatch(GetPendingCollaborationsCount({ header, data }));
      } catch (error) { }
    }
  };

  // const [inputType, setInputType] = useState("date");

  // function handleFocus() {
  //   setInputType("date");
  //   document.getElementById("dateInput").showPicker();
  // }

  // function handleBlur() {
  //   setInputType("text");
  // }

  const handleInputChange = (event, key) => {
    if (key && key === "address") {
      setInputFields((state) => ({
        ...state,
        [modalType]: state[modalType]?.map((field) =>
          field.key === "company_address" || field.key === "address"
            ? { ...field, value: event }
            : field
        ),
      }));
    }
    if (event?.target) {
      const { name, value } = event?.target;
      setInputFields((state) => ({
        ...state,
        [modalType]: state[modalType]?.map((field) =>
          field.key === name ? { ...field, value: value } : field
        ),
      }));
    } else {
      setInputFields((state) => ({
        ...state,
        [modalType]: state[modalType]?.map((field) =>
          field.key === "phone_number" || field.key === "contact_details"
            ? { ...field, value: event }
            : field
        ),
      }));
    }
  };

  const handleRegisterPress = async (modalType) => {
    try {
      const data = {};
      data.role = role;
      if (validateSignupFields(role)) {
        inputFields[modalType].forEach((obj) => {
          if (obj.value !== "") {
            data[obj.key] =
              obj.key === "gender"
                ? obj.value.charAt(0).toLowerCase() + obj.value.slice(1)
                : obj.value;
          }
        });
        dispatch(RegisterApi({ data }));
      }
    } catch (error) {
      setErrors(error?.response?.data?.errors);
    }
  };

  const validateSignupFields = (userRole) => {
    // 2 is for Brands || 1 is for Creator
    let inputData = inputFields[modalType];
    if (inputData) {
      if (userRole === "2" || userRole === 2) {
        let userErrors = new Map();
        inputData.map((mapVal, index) => {
          if (mapVal.key === "brand_name" && mapVal.value === "") {
            userErrors.set("brand_name", ["Name can not be empty!"]);
          }
          if (mapVal.key === "brand_name" && mapVal.value.length < 3) {
            userErrors.set("brand_name", ["Please enter a valid name!"]);
          }
          if (mapVal.key === "email") {
            if (!mapVal.value) {
              // Check if the email value is empty or contains only whitespace
              userErrors.set("email", ["The email field is required."]);
            } else if (!validateEmail(mapVal.value)) {
              userErrors.set("email", ["Please enter a valid email!"]);
            }
          }
          if (mapVal.key === "contact_details") {
            if (!mapVal.value || mapVal.value.length === 0) {
              userErrors.set("contact_details", [
                "Please enter a contact number!",
              ]);
            } else if (mapVal.value.length < 5) {
              userErrors.set("contact_details", [
                "Please enter a valid contact number!",
              ]);
            }
          }

          if (mapVal.key === "company_address" && !mapVal.value.length) {
            userErrors.set("company_address", [
              "Please enter a company address!",
            ]);
          }

          if (mapVal.key === "password") {
            if (!mapVal.value) {
              userErrors.set("password", ["Please enter a valid password!"]);
            } else if (mapVal.value.length < 7) {
              userErrors.set("password", [
                "The password must be at least 7 characters.",
              ]);
            }
          }

          if (mapVal.key === "password_confirmation") {
            if (!mapVal.value) {
              userErrors.set("password_confirmation", [
                "Please confirm your password!",
              ]);
            } else if (mapVal.value.length < 7) {
              userErrors.set("password_confirmation", [
                "The password must be at least 7 characters.",
              ]);
            } else if (
              mapVal.value !==
              inputData.find((item) => item.key === "password").value
            ) {
              userErrors.set("password_confirmation", ["Password mismatch!"]);
            }
          }
          return userErrors;
        });
        if (userErrors.size > 0) {
          setErrors(userErrors);
          return false;
        } else {
          return true;
        }
      } else if (userRole === 1 || userRole === "1") {
        let userErrors = new Map();
        inputData.map((mapVal, index) => {
          if (mapVal.key === "profile_name" && mapVal.value === "") {
            userErrors.set("profile_name", ["Name can not be empty!"]);
          }
          if (mapVal.key === "profile_name" && mapVal.value.length < 3) {
            userErrors.set("profile_name", ["Please enter a valid name!"]);
          }
          if (mapVal.key === "email") {
            if (mapVal.value.length < 1) {
              userErrors.set("email", ["The email field is required."]);
            }
            if (mapVal.value.length > 0 && !validateEmail(mapVal.value)) {
              userErrors.set("email", ["Please enter a valid email!"]);
            }
          }
          if (mapVal.key === "date_of_birth" && mapVal.value.length < 5) {
            userErrors.set("date_of_birth", [
              "Please enter your date of birth!",
            ]);
          }
          if (mapVal.key === "address" && !mapVal.value.length) {
            userErrors.set("address", ["Please enter an address!"]);
          }
          if (mapVal.key === "gender" && mapVal.value.length < 1) {
            userErrors.set("gender", ["Please select your gender!"]);
          }

          if (mapVal.key === "phone_number") {
            if (!mapVal.value || mapVal.value.length === 0) {
              userErrors.set("phone_number", ["Please enter a phone number!"]);
            } else if (mapVal.value.length < 5) {
              userErrors.set("phone_number", [
                "Please enter a valid phone number!",
              ]);
            }
          }

          if (mapVal.key === "password") {
            if (!mapVal.value) {
              userErrors.set("password", ["Please enter a valid password!"]);
            } else if (mapVal.value.length < 7) {
              userErrors.set("password", [
                "The password must be at least 7 characters.",
              ]);
            }
          }

          if (mapVal.key === "password_confirmation") {
            if (!mapVal.value) {
              userErrors.set("password_confirmation", [
                "Please confirm your password!",
              ]);
            } else if (mapVal.value.length < 7) {
              userErrors.set("password_confirmation", [
                "The password must be at least 7 characters.",
              ]);
            } else if (
              mapVal.value !==
              inputData.find((item) => item.key === "password").value
            ) {
              userErrors.set("password_confirmation", ["Password mismatch!"]);
            }
          }
          return userErrors;
        });
        if (userErrors.size > 0) {
          setErrors(userErrors);
          return false;
        } else {
          return true;
        }
      } else if (forgotPassOptions) {
        let userErrors = new Map();
        inputData.map((mapVal, index) => {
          if (mapVal.key === "email") {
            if (mapVal.value.length < 1) {
              userErrors.set("email", ["The email field is required."]);
            }
            if (mapVal.value.length > 0 && !validateEmail(mapVal.value)) {
              userErrors.set("email", ["Please enter a valid email!"]);
            }
          }
          return userErrors;
        });

        if (userErrors.size > 0) {
          setErrors(userErrors);
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  };

  const handleLoginPress = async (modalType) => {
    console.log({ modalType })
    try {
      const data = {};
      data.role = data.login_type = role;

      inputFields[modalType].forEach((obj) => {
        data[obj.key] = obj.value;
      });

      if (isSupported()) {
        await Notification.requestPermission();
        const token = await requestForToken();
        console.log("Firebase token:", token);
        data["firebase_token"] = token;
      } else {
        console.warn("Notifications are not supported in this browser.");
      }


      dispatch(LoginApi({ data }));
    } catch (error) {
      console.log({ error })
      // TODO: Handle Errors Here
      // handleLoginError(error);
    }
  };

  const handleLoginError = (error) => {
    if (error?.errors) {
      setErrors(error?.errors);
    } else {
      setErrors(error?.error);
    }
  };

  const handleForgotPassword = async (modalType) => {
    try {
      if (validateSignupFields(null)) {
        const data = {};
        data.role = data.login_type = role;

        inputFields[modalType].forEach((obj) => {
          data[obj.key] = obj.value;
        });

        dispatch(ForgotPasswordApi({ data }));
      }
    } catch (error) {
      // TODO: Handle Errors Here
      // handleLoginError(error);
    }
  };

  const getNotifications = async () => {
    try {
      console.log('Get Notifications');
      dispatch(getNotificationsApi({ token }));
    } catch (error) {
      console.log(error);
      // TODO: Handle Errors Here
      //
      // if (error?.response?.data?.errors) {
      //   setErrors(error?.response?.data?.errors);
      // } else {
      //   setErrors(error?.response?.data?.error);
      // }
    }
  };

  const handleErrors = (errors) => {
    console.log({ errors, ty: typeof errors });
    if (errors) {
      setInputFields((prevInputFields) => ({
        ...prevInputFields,
        [modalType]: inputFields[modalType]?.map((field) => {
          let fieldError = "";
          if (typeof errors === "object" && errors[field.key]) {
            fieldError = errors[field.key];
          } else if (typeof errors === "string" && field.key === "password") {
            fieldError = errors;
          } else if (typeof errors === "object" && errors instanceof Map) {
            fieldError = errors.get(field.key);
          }
          return { ...field, error: fieldError };
        }),
      }));
    }
  };


  const handleCloseModal = () => {
    setInputFields(INITIAL_FIELDS);
  };

  const dropdownOpen = (event, callback) => {
    const obj = event.currentTarget;
    if (window.$(obj).find(".inner-dropdown").hasClass("open")) {
      window.$(obj).find(".inner-dropdown").removeClass("open");
    } else {
      window.$(".inner-dropdown").removeClass("open");
      window.$(obj).find(".inner-dropdown").addClass("open");
      window.$(obj).find(".inner-dropdown").removeClass("d-none");
    };
  }


  const dropdownBox = (event) => {
    event.stopPropagation();
  };

  const handleNotificationPress = () => {
    setNotifications(true);
    getNotifications();
  };

  const handleLogOutPress = async () => {
    localStorage.removeItem("currentStep");
    try {
      await dispatch(logout());
      persistor.purge(); // Clear the persisted state safely
      navigate("/");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  const avatarUrl = user && user?.brand
    ? user?.brand.profile_image_thumb || '/assets/images/user.png'
    : user && user?.creator
      ? user?.creator.profile_image_thumb || '/assets/images/user.png'
      : '/assets/images/user.png'

  const navbarItems = [
    { label: "Home", link: "/", roles: [""] },
    { label: "About us", link: "/about", roles: [""] },
    { label: "Campaigns", link: "/creatorCampaigns", roles: ["1"], icon: <CampaignNavIcon />, iconActive: <CampaignActiveNavIcon /> },
    { label: "Brands", link: "/brandCatalogue", roles: ["1"], icon: <BrandNavIcon />, iconActive: <BrandActiveNavIcon /> },
    {
      // label: "Other Creators",
      label: "Creators",
      link: "/creatorsCatalogue", roles: ["1"], icon: <CreatorNavIcon />, iconActive: <CreatorActiveNavIcon />
    },
    {
      //  label: "Collaborations",
      label: "Collabs",
      link: "/collabration", roles: ["1"], icon: <CollaborationNavIcon />, iconActive: <CollaborationActiveNavIcon />
    },
    { label: "Packages", link: "/packs/view", roles: ["1"], icon: <PackNavIcon />, iconActive: <PackActiveNavIcon /> },
    // { label: "Messages", link: "/creatorChat", roles: ["1"] },
    { label: "Profile", link: "/creatorsProfile", roles: ["1"], icon: <ProfileNavIcon avatarUrl={avatarUrl} key={`profile-${avatarUrl || "default"}`} />, iconActive: <ProfileNavIcon avatarUrl={avatarUrl} isActive key={`profile-${avatarUrl || "default"}`} /> },
    //
    {
      // label: "My Campaigns", 
      label: "Campaigns",
      link: "/myCampaigns", roles: ["2"], icon: <CampaignNavIcon />, iconActive: <CampaignActiveNavIcon />
    },
    {
      // label: "Other Brands",
      label: "Brands",
      link: "/brandCatalogue", roles: ["2"], icon: <BrandNavIcon />, iconActive: <BrandActiveNavIcon />
    },
    { label: "Creators", link: "/creatorsCatalogue", roles: ["2"], icon: <CreatorNavIcon />, iconActive: <CreatorActiveNavIcon /> },
    {
      // label: "Collaborations",
      label: "Collabs",
      link: "/collabration", roles: ["2"], icon: <CollaborationNavIcon />, iconActive: <CollaborationActiveNavIcon />
    },
    {
      label: "Profile", link: "/brandProfile", roles: ["2"], icon: <ProfileNavIcon avatarUrl={avatarUrl} key={`profile-${avatarUrl || "default"}`} />, iconActive: <ProfileNavIcon avatarUrl={avatarUrl} isActive key={`profile-${avatarUrl || "default"}`} />
    },
    // { label: "Messages", link: "/creatorChat", roles: ["2"] },
  ];

  const navbarHeaderItems = [];

  const handleLinkClick = () => {
    const currentPath = location.pathname;
    const userRole = user?.role;
    if (userRole === "1" && currentPath === "/brandCatalogue") {
      window.location.reload();
    } else if (userRole === "2" && currentPath === "/creatorsCatalogue") {
      window.location.reload();
    }
  };

  const MAX_AGE = 200;
  const MIN_AGE = 10;

  const getMinAndMaxDateForDob = () => {
    const currenTime = new Date();
    const currentYear = currenTime.getFullYear();
    const currentMonth = currenTime.getMonth(); // 0-11
    const month = String(currentMonth + 1).padStart(2, '0'); // "01"..."12"

    const minYear = currentYear - MAX_AGE;
    const maxYear = currentYear - MIN_AGE;

    const minDate = moment(`${minYear}-${month}-01`, 'YYYY-MM-DD'); // ✅ chuẩn ISO
    const maxDate = moment(`${maxYear}-${month}-01`, 'YYYY-MM-DD');

    return { minDate, maxDate };
  };



  useEffect(() => {
    if (token !== "") {
      getUnreadMessages();
      getPendingCollaborationRequest();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error) {
      setErrors(error?.payload?.errors);
    }
    if (loginError) {
      handleLoginError(loginError);
    }
  }, [loading, error, loginError]);

  useEffect(() => {
    const filteredNavbar = token
      ? navbarItems.filter(
        (navbarItem) => user && navbarItem.roles.includes(user?.role)
      )
      : navbarItems.slice(0, 2);
    setFilterNavbarItems(filteredNavbar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (errors) {
      handleErrors(errors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('signup') === 'brand') {
      const element = document.getElementById(ELEMENT_IDS.BTN_SIGN_UP_FROM_LP);
      element?.click();
      setModalType("signUpAsBrand");
      setSignUpOptions(false);
      setRole(2);
    } else if (params.get('signup') === 'creator') {
      const element = document.getElementById(ELEMENT_IDS.BTN_SIGN_UP_FROM_LP);
      element?.click();
      setModalType("signUpAsCreator");
      setSignUpOptions(false);
      setRole(1);
    }
  }, [location]);

  useEffect(() => {
    // Define the routes that can be accessed without authentication
    const openRoutes = [
      '/',
      '/about',
      '/contactUs',
      '/privacy-policy',
      '/termsAndConditions',
      '/mainHelp',
      '/brandHelp',
      '/creatorsHelp',
      '/agencyInvite',
      '/forgot-password',
    ];

    const handleStorageChange = () => {
      const user = localStorage.getItem("user");
      const token = localStorage.getItem("token");

      if (!user && !token && !openRoutes.includes(location.pathname)) {
        dispatch(logout());
        navigate("/"); // check late => same same NavbarForgotPassword but cmt this line
      } else if (!user && !token && openRoutes.includes(location.pathname)) {
        dispatch(logout());
      }
    };

    // Set up event listener for storage changes
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      // clearInterval(intervalId);
    };
  }, [navigate, location, dispatch]);

  useEffect(() => {
    if (success) {
      document.getElementById("logIn-modal-close")?.click();
      if (user) {
        if (user?.email_verified_at) {
          if (user?.data?.first_time_login) {
            navigate("/welcome");
            dispatch(resetLoadSuccessStates());
          } else {
            if (user?.role === "1" || user?.role === 1) {
              //
              navigate("/brandCatalogue");
              dispatch(resetLoadSuccessStates());
            } else {
              //
              navigate("/creatorsCatalogue");
              dispatch(resetLoadSuccessStates());
            }
          }
        } else {
          navigate("/otpVerification");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);


  useEffect(() => {
    if (signUpSuccess) {
      if (modalType === "signUpAsBrand" || modalType === "signUpAsCreator") {
        // setUser(user?.data?.user);
        document.getElementById("signUp-modal-close").click();
        dispatch(resetLoadSuccessStates());
        navigate("/otpVerification");
      }
    }

    if (forgotPassSuccess) {
      document.getElementById("forgotPass-modal-close")?.click();
      dispatch(resetLoadSuccessStates());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signUpSuccess, forgotPassSuccess]);


  useFetchUserData();


  return (
    <>
      <nav className={`navbar navbar-expand-lg tw-w-full ${!isDisplayHeaderAtMobile ? "tw-show-desktop-flex" : ""}`}>
        <div className="container-fluid tw-pr-0 tw-flex-nowrap">
          <button
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            // className="navbar-toggler"
            className={`navbar-toggler tw-relative navbar-custom ${isLogin ? "tw-hidden" : "tw-block"} sm:tw-block tw-z-[100] border-0 tw-ml-4 tw-p-2 tw-rounded-full hover:tw-bg-white/20 tw-transition-colors`}
            type="button"
          >
            <Menu size={24} />

            {(unReadMessagesCount && typeof unReadMessagesCount == 'number') ? (
              <div className="tw-absolute tw-left-[25px] tw-bottom-[25px] tw-min-w-[20px] tw-h-[20px] tw-rounded-full tw-bg-[#65acae] tw-flex tw-justify-center tw-items-center tw-text-white tw-text-[14px] tw-px-[6px] tw-py-[4px] tw-font-extrabold tw-whitespace-nowrap">
                <div>{unReadMessagesCount}</div>
              </div>
            ) : null}
          </button>


          {titlePageReplaceLogoAtMobile && <div
            className="tw-pl-[15px]"
          >
            <TitleHeaderPage className="tw-show-mobile tw-my-0 tw-text-[24px]" text={titlePageReplaceLogoAtMobile} />
          </div>}


          <Link
            className={`tw-flex tw-m-auto tw-ml-0 lg:tw-mr-auto md:tw-ml-0 sm:tw-mr-auto
              ${titlePageReplaceLogoAtMobile && "tw-show-desktop-flex"}
              `}
            to={
              user !== null
                ? user?.role === "1"
                  ? "/brandCatalogue"
                  : "/creatorsCatalogue"
                : "/"
            }
            onClick={handleLinkClick}
          >
            {user !== null ? (
              <>
                <div className="logo-size max-[320px]:tw-w-[130px]">
                  <CreatorCatalogueLogo />
                </div>
              </>
            ) : (
              <>
                <div className="tw-flex tw-ms-3 tw-flex-row tw-items-end">
                  <CreatorCLogo className="tw-h-11" />
                  <span className="tw-ml-2 tw-h-7 md:tw-h-8 tw-font-bold tw-text-sm md:tw-text-base tw-px-2 tw-py-1 tw-border tw-border-primary tw-rounded-lg">
                    Creator Catalogue
                  </span>
                </div>
                {/* <img
                  className="logo-size"
                  src="/assets/images/LP-logo.svg"
                  alt="Vitrine"
                /> */}
              </>
            )}
            {user !== null ? (
              <div className="--beta-logo tw-font-power tw-text-center tw-text-white tw-tracking-[1px] max-[360px]:tw-text-[9px] tw-text-[13px] sm:tw-text-[14px]">
                <div className="tw-bg-[#549a9c] tw-rounded-tl-[11px] tw-rounded-br-[11px] max-[360px]:tw-mt-[13px] tw-mt-[11px] sm:tw-mt-[13px] tw-py-[2px] tw-pt-[4px] tw-px-[7px]">BETA</div>
              </div>) : null}
          </Link>

          {/* <<<<=== NAVBAR FOR OTHER THAN MOBILE ===>>>>  */}
          <NavbarDesktopV2
            dropdownOpen={dropdownOpen}
            dropdownBox={dropdownBox}
            handleNotificationPress={handleNotificationPress}
            handleLogOutPress={handleLogOutPress}
            setErrors={setErrors}
            setLogInOptions={setLogInOptions}
            setShowPassword={setShowPassword}
            setShowConfirmPassword={setShowConfirmPassword}
            setModalType={setModalType}
            setSignUpOptions={setSignUpOptions}
            setRole={setRole}
          />
          {/* <<<<=== NAVBAR FOR OTHER THAN MOBILE ===>>>>  */}

        </div>
      </nav>
      {notifications ? (
        <NotificationsPanel setNotifications={setNotifications} />
      ) : null}

      {/* <<<<=== NAVBAR FOR MOBILE ===>>>>  */}
      {isDisplayMenuAtMobile && <MobileNavbar
        filteredNavbarItems={filteredNavbarItems}
        location={location}
        user={user}
        handleNotificationPress={handleNotificationPress}
        handleLogOutPress={handleLogOutPress}
        setLogInOptions={setLogInOptions}
        setSignUpOptions={setSignUpOptions}
        ELEMENT_IDS={ELEMENT_IDS}
      />}


      {/* Mobile Navigation Menu Overlay */}
      {isOpen && (
        <div className={`tw-fixed tw-inset-0 tw-bg-black/50 tw-animate-fade-in --lg:tw-hidden ${notifications ? "tw-z-[100]" : "tw-z-[10000000000]"}`}>
          <div className="tw-absolute tw-right-0 sm:tw-left-0 tw-top-0 tw-bottom-0 tw-w-4/5 sm:tw-w-[130px] tw-max-w-xs tw-bg-white tw-shadow-xl animate-slide-in-right">
            <div className="tw-p-4 tw-flex tw-justify-between tw-items-center tw-border-b">
              <h2 className="tw-font-semibold tw-text-teal-800 sm:tw-hidden">Menu</h2>
              <button
                className="tw-p-2 tw-rounded-full hover:tw-bg-gray-100"
                onClick={() => setIsOpen(false)}
              >
                <X className="tw-block sm:tw-hidden" size={20} />
                <Menu className="tw-hidden sm:tw-block" size={24} />
              </button>
            </div>

            <nav className="tw-p-2">
              {filteredNavbarItems.map((navbarItem) => {
                const isActive = location.pathname === navbarItem.link;
                return <NavItemButton
                  key={`nav-main-${navbarItem.label}`}
                  label={navbarItem.label}
                  icon={isActive ? navbarItem?.iconActive : navbarItem?.icon}
                  isActive={isActive}
                  onClick={() => {
                    // setCurrentPage(item.toLowerCase());
                    setIsOpen(false);
                    navigate(navbarItem.link);
                  }}
                  unReadMessagesCount={unReadMessagesCount}
                />
              })}

              {user !== null ? (
                <>
                  <NavItemButton
                    className="text-danger"
                    label={"Logout"}
                    onClick={() => {
                      handleLogOutPress();
                    }}
                  />
                </>
              ) : (
                <>
                  <div className="text-center mt-5 mx-4">
                    <div
                      id={ELEMENT_IDS.BTN_LOG_IN_FROM_LP}
                      data-bs-toggle="modal"
                      data-bs-target="#logInModal"
                      onClick={() => {
                        setLogInOptions(true);
                        setIsOpen(false);
                      }}
                    >
                      <button className="tw-bg-primary tw-w-full tw-text-white tw-font-semibold tw-py-3 tw-rounded-lg">
                        Login
                      </button>
                    </div>
                    <div className="my-2">OR</div>
                    <div
                      id={ELEMENT_IDS.BTN_SIGN_UP_FROM_LP}
                      onClick={() => {
                        setSignUpOptions(true);
                        setIsOpen(false);
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#signUpModal"
                    >
                      <button className="tw-bg-white tw-w-full tw-text-primary tw-border tw-border-primary tw-font-semibold tw-py-3 tw-rounded-lg">
                        Sign up
                      </button>
                    </div>
                  </div>
                </>
              )}
            </nav>

            {user !== null && <div className={"tw-show-mobile tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-p-4 tw-border-t"}>
              <div className="tw-flex tw-items-center tw-space-x-3 tw-cursor-pointer"
                onClick={() => {
                  if (user !== null) {
                    if (user?.role === "1") {
                      navigate("/creatorsProfile");
                    } else if (user?.role === "2") {
                      navigate("/brandSetting");
                    }
                  }
                }}
              >
                <div className="tw-w-10 tw-h-10 tw-rounded-full tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-bg-gray-200">
                  <img
                    src={
                      avatarUrl
                    }
                    alt="User"
                    className="tw-w-full tw-h-full tw-object-cover"
                  />
                </div>

                <div>
                  <div className="tw-text-sm tw-font-medium">Your Profile</div>
                  <div className="tw-text-xs tw-text-gray-500">View account settings</div>
                </div>
              </div>
            </div>}

          </div>
        </div>
      )}


      <div className="section-color-nav">
        <nav className=" w-100">
          <div>
            <div
              className="collapse navbar-collapses"
              id="navbarSupportedContents"
            >
              <ul className="d-flex m-0 align-items-center">
                <div className="button-box">
                  {/* ======Brand/Creator Signup Model Start=========== */}
                  <ModalWrapper id="signUpModal">
                    {signUpOptions ? (
                      <>
                        <SignUpOptionsModal
                          setSignUpOptions={setSignUpOptions}
                          setModalType={setModalType}
                          setRole={setRole}
                        />
                      </>
                    ) : (
                      <>
                        <SignUpModalWrapper
                          modalType={modalType}
                          setSignUpOptions={setSignUpOptions}
                          setErrors={setErrors}
                          handleCloseModal={handleCloseModal}
                          loading={loading}
                          handleRegisterPress={handleRegisterPress}
                          isTyped={(modalType === "signUpAsBrand" ? inputFields.signUpAsBrand : inputFields.signUpAsCreator).every(field => field.value.trim() !== "")}
                        // const isTyped = inputFields.logInFields.every(field => field.value.trim() !== "");
                        >
                          <SignUpFormFields
                            fields={modalType === "signUpAsBrand" ? inputFields.signUpAsBrand : inputFields.signUpAsCreator}
                            errors={errors}
                            modalType={modalType}
                            handleInputChange={handleInputChange}
                            // handleRegisterPress={handleRegisterPress}
                            showPassword={showPassword}
                            setShowPassword={setShowPassword}
                            showConfirmPassword={showConfirmPassword}
                            setShowConfirmPassword={setShowConfirmPassword}
                          />
                        </SignUpModalWrapper>
                      </>
                    )}
                  </ModalWrapper>
                  {/* ======Brand/Creator Signup Model End=========== */}
                  {/*===================Main login button Modal Start================== */}
                  <AuthModal
                    setIsOpen={setIsOpen}
                    logInOptions={logInOptions}
                    forgotPassOptions={forgotPassOptions}
                    setSignUpOptions={setSignUpOptions}
                    setLogInOptions={setLogInOptions}
                    setForgotPassOptions={setForgotPassOptions}
                    modalType={modalType}
                    setModalType={setModalType}
                    setRole={setRole}
                    role={role}
                    inputFields={inputFields}
                    setErrors={setErrors}
                    handleInputChange={handleInputChange}
                    handleForgotPassword={handleForgotPassword}
                    handleLoginPress={handleLoginPress}
                    handleCloseModal={handleCloseModal}
                    showPassword={showPassword}
                    setShowPassword={setShowPassword}
                    showConfirmPassword={showConfirmPassword}
                    setShowConfirmPassword={setShowConfirmPassword}
                    loading={loading}
                    forgotPassLoading={forgotPassLoading}
                  />
                  {/*===================Main login button Modal End================== */}
                </div>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
